//@ts-check

class InternalLinksService {
	constructor($http, $window, $timeout, $rootScope, LocalStorageService) {
		this.$http = $http;
		this.$window = $window;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.LocalStorageService = LocalStorageService;
	}

	/**
	 * Function for getting the links allowed on an API
	 * @param {string} path The path to be added to the base URL
	 * @param {boolean} isAuthenticating The flag for whether to use the authentication URL or not
	 * @return {Promise<Object>} the links promise
	 */
	async getLinks(path, isAuthenticating, isNew, isMobileApp) {
		let url, promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			url = isAuthenticating
				? `${authenticationAPIAddress}${authenticationAPIAddress.endsWith('/') ? '' : '/'}authentication/`
				: pretorOnlineUrl;

			url = isNew ? `${url.toLowerCase().replace('authentication', 'accounts')}` : url;
			url = isNew ? `${url.toLowerCase().indexOf('account') !== -1 ? url : url + '/api/accounts'}/${path}` : url;

			if (isMobileApp) {
				//TODO: Start here for mobile app(Glovent)
				const mobileApiAddress = this.LocalStorageService.retrieve('mobileApiAddress');
				url = `${mobileApiAddress}${mobileApiAddress.endsWith('/') ? '' : '/'}${path}`;
			}

			if (url.indexOf(path) === -1) {
				url = url + path;
			}

			const urls = await this.$http.get(url);
			//console.log('Got new links: ' + JSON.stringify(urls));
			this.saveLink(urls.data);
			this.$timeout(() => promiseHandler.resolve(urls.data));
		} catch (error) {
			const msg = `Error loading URL links from: ${url}\nError: `;
			console.error(msg, error);
			this.$timeout(() => promiseHandler.reject(msg));
		}

		return promise;
	}

	/**
	 * Function for getting a stored link
	 * @param {string} name The name of the URL required
	 * @return {string} the required URL
	 */
	getLink(name) {
		var link = undefined;
		link = this.LocalStorageService.retrieve(name);
		return link;
	}

	/**
	 * Function for storing a link
	 * @param {string} name The name of the URL required
	 * @return {string} the required URL
	 */
	saveLink(urls) {
		var linksToSave = urls.hasOwnProperty('data') ? urls.data : urls;
		Object.keys(linksToSave).forEach((key) => {
			var value = linksToSave[key];
			this.LocalStorageService.save(key, value);
		});
	}
}

export default /* @ngInject */ ($http, $window, $timeout, $rootScope, LocalStorageService) =>
	new InternalLinksService($http, $window, $timeout, $rootScope, LocalStorageService);
